module.exports = __webpack_public_path__ + "img/medici.313e20b3.jpg";